module.exports = __webpack_public_path__ + "static/arotiba-5385fb2d00b62cd50196b06fc9790170.png";